import { useEffect, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from '@tanstack/react-router'

import { canPlayCard } from '~/boundedContext/cards/utils/card'
import { LinkButton } from '~/components/link-button'
import { useCardsGameStore } from '~/stores/cards-game'

export const NoCards = () => {
  const { t } = useTranslation()
  const allCards = useCardsGameStore(state => state.allCards)
  const cardsExceptSnoozed = useMemo(() => allCards.filter(card => canPlayCard(card)), [allCards])
  const navigate = useNavigate()

  useEffect(() => {
    if (cardsExceptSnoozed?.length) void navigate({ to: '/cards' })
  }, [cardsExceptSnoozed?.length, navigate])

  return (
    <div className="relative flex h-full items-center justify-center overflow-hidden">
      <LinkButton to="/list">{t('Add new cards')}</LinkButton>
    </div>
  )
}
